import io from "socket.io-client";
import { API_ENDPOINT, API_ENDPOINT_SOCKET } from "../../AppConfig.js";

import {
  FETCH_CONTACT_US_COUNT,
  FETCH_TALENT_COUNT,
  FETCH_Organization_COUNT,
  CLEAR_MESSAGE,
  FETCH_Order_Talent_COUNT,
  FETCH_New_Message,
  FETCH_UPDATE_ROLE,
} from "./type";
import cookie from "react-cookies";
import { MyTicket_USER } from "../../AppConfig";
import { sendLogout } from "./LoginAction.js";
let socketChat = null;
let socketonlineOrder = null;
let USerRole = null;

export function init() {
  return (dispatch, getState) => {
    // let user = cookie.load(`${MyTicket_USER}`, true);
    let user =
      sessionStorage.getItem(`${MyTicket_USER}`) !== null &&
      sessionStorage.getItem(`${MyTicket_USER}`) !== undefined &&
      sessionStorage.getItem(`${MyTicket_USER}`);
    USerRole = io(`${API_ENDPOINT_SOCKET}/utils`, {
      query: {
        id: user && JSON.parse(user) ? JSON.parse(user).id : null,
      },
    });
    USerRole.on("connect", () => {
    });
    USerRole.on("NewUser", (data) => {
      dispatch({ type: FETCH_UPDATE_ROLE, payload: data.user });
    });

    socketonlineOrder = io(`${API_ENDPOINT_SOCKET}/admin`, {
      query: {
        id: user && JSON.parse(user) ? JSON.parse(user).id : null,
      },
    });

    socketonlineOrder.on("connect", () => {
    });
    socketonlineOrder.on("TalentsCount", (data) => {
      dispatch({ type: FETCH_TALENT_COUNT, payload: data.count });
    });
    socketonlineOrder.on("OrganizationsCount", (data) => {
      dispatch({ type: FETCH_Organization_COUNT, payload: data.count });
    });
    socketonlineOrder.on("OrderTalentCount", (data) => {
      dispatch({ type: FETCH_Order_Talent_COUNT, payload: data.count });
    });


    
    socketChat = io(`${API_ENDPOINT_SOCKET}/chat`, {
      query: {
        id: user && JSON.parse(user) ? JSON.parse(user).id : null,
        token: getState().userInfo.token
      },
    });

    socketChat.on("connect", () => {
    });

    socketChat.on("NewMessageCount", (data) => {
      dispatch({ type: FETCH_CONTACT_US_COUNT, payload: data.count });
    });

    socketChat.on("NewMessage", (data) => {
      dispatch({ type: FETCH_New_Message, payload: data });
    });

    socketChat.on('autherr', function(err) {
      // dispatch(sendLogout());
    });

  };
}
export function clear() {
  return (dispatch, getState) => {
    dispatch({ type: CLEAR_MESSAGE });
  };
}
